import { IEventrHireCar } from "@eventr/common";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { routes } from "routing";
import { getCategoryProperties } from "utils";
import { useScreenTypeContext } from "v2/state/screenTypeProvider";
import { HireCarHeader } from "./hireCarComponents/hireCarHeader";
import { HireCarInfo } from "./hireCarComponents/hireCarInfo";
import { ObjectProvider } from "./providers/objectProvider";
import { BaseCard } from "./subComponents/baseCard";

interface HireCarCardProps {
  id?: string;
  data: IEventrHireCar;
  past?: boolean;
  border?: boolean;
  date?: string | undefined;
}

export default function HireCarCard({ id, data, past = false, date }: HireCarCardProps) {
  const { screenType } = useScreenTypeContext();
  const { pushPath } = useGlobalRouter();

  const handleClick = () => {
    if (data._id && screenType !== "edit") {
      pushPath(routes.item.hireCar.build({ itemId: data._id }), { state: { screenType, date } });
    }
  };

  return (
    <ObjectProvider past={past} _id={data._id} sectionID="4">
      <BaseCard id={id} past={past} onClick={handleClick}>
        <HireCarHeader
          category={getCategoryProperties(data?.categories?.[0])}
          car_alias={data.car_alias}
          label={data.label}
          labelTime={data.labelTime}
          pick_up={data.pick_up}
          drop_off={data.drop_off}
          date={date}
          visibility={data.visibility}
        />
        <HireCarInfo
          pick_up={data.pick_up}
          drop_off={data.drop_off}
          pick_up_location={data.pick_up_location}
          drop_off_location={data.drop_off_location}
          booking_ref={data.booking_reference}
          documents={data.extra_docs}
          additional_info={data.comments}
          passengers={data.passengers_list}
          vehicle_type={data.vehicle_type}
          provider={data.provider}
          chatNames={[data.car_alias]}
        />
      </BaseCard>
    </ObjectProvider>
  );
}
